import { render, staticRenderFns } from "./wb-toolbar.vue?vue&type=template&id=3b379840&scoped=true"
import script from "./wb-toolbar.vue?vue&type=script&lang=js"
export * from "./wb-toolbar.vue?vue&type=script&lang=js"
import style0 from "./wb-toolbar.vue?vue&type=style&index=0&id=3b379840&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b379840",
  null
  
)

export default component.exports